export const environment = {
  production: false,
  baseHref: '/',
  redirectUri: 'https://newptm.ukgreetings.co.uk/',
  postLogoutRedirectUri: 'https://newptm.ukgreetings.co.uk/',
  webApi: 'https://newptm-api.ukgreetings.co.uk',
  tablePaginationSizes: [10, 25, 100],
  pageableAllItems: 99999,
  noLoadingSpinnerHeader: 'loading-spinner-disabled',
  httpRequestChunkSize: 100
};
